(function() {
  var ContactsHandler, DeleteDialog,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  ContactsHandler = App.loadClass("grower::handlers/contacts/Contacts_Handler");

  DeleteDialog = App.loadClass("core::DeleteDialog");

  exports.Contacts_Tab_Handler = (function(superClass) {
    extend(Contacts_Tab_Handler, superClass);

    function Contacts_Tab_Handler() {
      return Contacts_Tab_Handler.__super__.constructor.apply(this, arguments);
    }

    Contacts_Tab_Handler.prototype.init = function() {
      var msgwriter;
      this.layoutUrl = "backend/grower/contacts/contactstab/load-layout";
      this.layoutSelector = "#contactstab_contacts";
      msgwriter = App.sidebar.messageWriter();
      msgwriter.message_writer();
      msgwriter.message_writer('info', 'Loading...');
      return this.loadLayout();
    };

    Contacts_Tab_Handler.prototype.afterLoadLayout = function(selector, data) {
      var ths;
      ths = this;
      $(this.layoutSelector).find('.drop-btn').click(function(e) {
        var btn;
        btn = $(this);
        return $.post('backend/grower/contacts/contactstab/dropcontact-ajax', {
          'contact_id': $(this).data('contact_id')
        }, function(json) {
          if (json.status.type === 'success') {
            return btn.parents('tr').empty().append("<td class='removal_success'>Contact Dropped</td> <td></td> <td></td>");
          } else {
            return App.current_page.refreshSubHandlers();
          }
        });
      });
      $(this.layoutSelector).find('.block-btn').click(function(e) {
        var btn;
        btn = $(this);
        return ths.createDeleteDialog('Block User?', $(this).data('contact_id'), 'contacts/contactstab/blockcontact-ajax', btn);
      });
      this.bindPermissionSelChangeEvents(this.layoutSelector);
      return this.tabLoadLayoutCallback(selector, data);
    };

    Contacts_Tab_Handler.prototype.bindPermissionSelChangeEvents = function(layoutSelector) {
      var ths;
      ths = this;
      return $(layoutSelector).find('.sel-change-permission').change(function(e) {
        var original, sel, td;
        sel = $(this);
        td = sel.parents('td');
        original = td.html();
        sel.replaceWith('<text class="saving">Saving...</text>');
        return $.post('backend/grower/contacts/contactstab/updatepermission-ajax', {
          'contact_id': sel.data('contact_id'),
          'permission_id': sel.val()
        }, function(json) {
          if (json.status.type === 'success') {
            td.empty().append(original);
            td.children('select').replaceWith(json.data);
            return ths.bindPermissionSelChangeEvents(layoutSelector);
          } else {
            return App.current_page.refreshSubHandlers();
          }
        });
      });
    };

    Contacts_Tab_Handler.prototype.createDeleteDialog = function(type, user_id, saveUrl, btn) {
      var del, ths;
      ths = this;
      del = this.createSubHandler(DeleteDialog);
      if (del) {
        del.deleteItemID = user_id;
        del.saveUrl = saveUrl;
        del.delayAfterSuccess = true;
        del.deleteMessage = 'Are you sure that you want to block this contact';
        del.deleteTitle = 'Block Contact';
        del.buttonText = 'Block';
        del.override_title = true;
        del.override_message = true;
        del.override_btnText = true;
        del.successAction = function() {
          return btn.parents('tr').empty().append("<td class='removal_success'>Contact Blocked</td> <td></td> <td></td>");
        };
        return del.init();
      }
    };

    return Contacts_Tab_Handler;

  })(ContactsHandler);

}).call(this);
